(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["gaff-image-tab"]) return;
  try {
    
$(document).ready(function() {
  //image tab
  //desktop
  $('#tabs').on('click', 'div', function() {
    $('#img-container .image').removeClass('selected');

    var newImage = $(this).index();

    $('#img-container .image').eq(newImage).addClass('selected');

    $('#tabs div').removeClass('active');
    $(this).addClass('active');
  });

  //mobile
  $('#tabs-m').on('click', 'div', function() {
    $('#img-container-m .image').removeClass('selected');
    
    var newImage = $(this).index();
    
    $('#img-container-m .image').eq(newImage).addClass('selected');
    
    $('#tabs-m div').removeClass('active');
    $(this).addClass('active');
  });
  //image tab end
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speader-dimension"]) return;
  try {
    
$(document).ready(function() {
 
});


  } catch(e) { console.error(e); }
})();

})();
